import React, { useState, useEffect } from "react";
import { Row, Col, Popover, Descriptions, Skeleton } from "antd";
import { emp } from "api/endpoints";
import { getRequest } from "api";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";
import { errorMsg } from "utils/msg";
import { formatDateTimeUtc } from "utils/formatter";

function CreatedByInfo({ UserId, Date }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getRequest(`${emp.getUsername}/${UserId}`);
        setData(res.data);
      } catch (error) {
        errorMsg(error?.Msg);
      }
      setLoading(false);
    };

    if (visible) {
      fetchData();
    }
  }, [visible, UserId]);

  const content = () => {
    return (
      <Skeleton loading={loading} paragraph={false} size={"small"} active>
        <Descriptions title="Ажилтны мэдээлэл" size="small" bordered labelStyle={{ fontWeight: "500" }} column={1}>
          <Descriptions.Item label="Ажилтан">
            <Row gutter={12}>
              <Col>{data?.UserName}</Col>
              <Col>
                <a target="_blank" rel="noreferrer" href={`${emp.emp}/${UserId}`}>
                  <EyeOutlined />
                </a>
              </Col>
            </Row>
          </Descriptions.Item>
          {Date && <Descriptions.Item label="Огноо">{formatDateTimeUtc(Date)}</Descriptions.Item>}
        </Descriptions>
      </Skeleton>
    );
  };

  return (
    <Popover
      content={content}
      trigger="click"
      placement="left"
      onOpenChange={(visible) => {
        setVisible(visible);
      }}
      open={visible}
    >
      <Link>{UserId}</Link>
    </Popover>
  );
}

export default CreatedByInfo;
